import camelCase from "lodash/fp/camelCase";
function upperCamelCase(str) {
  return camelCase(str).replace(/^./, str2 => str2.toUpperCase());
}
export { upperCamelCase as default };